import { canUseDOM } from '@lib/canUseDOM';
export var getWebApp = canUseDOM ? function () {
  return Telegram.WebApp;
} : function () {
  return {};
};